import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M14 9h-4v6h4","key":"svg-1"}],["path",{"d":"M10 12h2.5","key":"svg-2"}]]

const IconMapEast = createReactComponent('outline', 'map-east', 'MapEast', __iconNode);

export default IconMapEast;